import React, { useEffect } from "react";
import { useDropzone } from "react-dropzone";
import {
  FileUploadIcon,
  FileUploadWidget,
  FileUploadCaption,
  FileDropzone,
} from "./file-drop.styles";
import { FileDropProps } from "./file-drop.props";

export const FileDrop = ({ accept, onDrop }: FileDropProps) => {
  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({ accept });

  useEffect(() => {
    if (acceptedFiles.length > 0) {
      onDrop(acceptedFiles);
    }
  }, [acceptedFiles, onDrop]);

  return (
    <FileDropzone {...getRootProps({ className: "dropzone" })}>
      <input {...getInputProps()} />

      <FileUploadWidget>
        <div>
          <FileUploadIcon />
        </div>
        <div>Upload</div>
      </FileUploadWidget>
      <FileUploadCaption>or drag and drop file to upload</FileUploadCaption>
    </FileDropzone>
  );
};
